if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.formQuantity = this.form.querySelector('[name=quantity]');
      // this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.variantSwitches = this.querySelectorAll('.product-form__sizes input');
      this.priceLabels = this.querySelectorAll('.price-line');
      this.stockLabels = this.querySelectorAll('.stock-level__label');

      this.setupEventListeners();
    }

    setupEventListeners() {
      document.addEventListener('quantityUpdated', (e) => {
        if (this.querySelector(`#Quantity-${e.detail.id}`) !== null) {
          let newQuantity = parseInt(e.detail.qty),
              quantityItem = this.querySelector(`#Quantity-${e.detail.id}`),
              totalMaxQuantity = parseInt(quantityItem.getAttribute('total-max')),
              addableQuantity = totalMaxQuantity - newQuantity,
              button = this.querySelector(`[data-product-id="${e.detail.id}"]`);
          quantityItem.setAttribute('max', addableQuantity);
          newQuantity == totalMaxQuantity ? this.changeButtonStatus(button,'disable') : this.changeButtonStatus(button,'enable');
          newQuantity == 0 && updatedItem.classList.add('hidden');
        }
      });

      this.variantSwitches.forEach((input) => {
        input.addEventListener('click', this.switchVariant.bind(this,input));
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        // this.cartNotification.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            this.error = true;
            return;
          } else if (!this.cartNotification) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', id: this.form.querySelector('.product-button').dataset.productId});
          this.error = false;
          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cartNotification && this.cartNotification.classList.contains('is-empty')) this.cartNotification.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    changeButtonStatus(button,status) {
      status == 'disable' ? button.disabled = true : button.disabled = false;
    }

    switchVariant(currentTarget) {
      this.stockLabels.forEach((label) => {
        label.classList.remove('active');
      });
      this.priceLabels.forEach((label) => {
        label.classList.remove('active');
      });
      setTimeout(() => {
        this.querySelector(`#stock--${currentTarget.value}`).classList.add('active');
        this.querySelector(`#price--${currentTarget.value}`).classList.add('active');
      }, 100);
    }
  });
}
